import { StorageService } from 'core-tsi'

// Claves de localStorage que sobreviven al cerrar sesión (mismo criterio que StorageService.clearStorage)
const PRESERVED_KEYS = new Set(['rucUser'])

export const getActiveSession = (): any => {
  try {
    const session = StorageService.getSession()
    return session && session.token ? session : null
  } catch {
    return null
  }
}

export const hasActiveSession = (): boolean => getActiveSession() != null

export const clearSessionStorage = () => {
  const keys = Object.keys(localStorage)
  let count = keys.length

  while (count--) {
    const key = keys[count]
    PRESERVED_KEYS.has(key) ? null : localStorage.removeItem(key)
  }
}
